<template>
  <div ref="containerRef" class="flex-center w-full max-w-screen">
    <div
      class="overflow-x-hidden relative w-full cursor-pointer group"
      @pointerover="isHover = true"
      @pointerleave="isHover = false"
    >
      <div class="marquee-track flex will-change-transform pb-6" :style="style">
        <div ref="list" class="flex flex-shrink-0 relative gap-[32px]">
          <ArticleCard v-for="(item, index) in data" :key="index" v-bind="item" />
        </div>
        <!-- Clone -->
        <div class="flex flex-shrink-0 relative gap-[32px] mx-[32px]">
          <ArticleCard v-for="(item, index) in data" :key="index" v-bind="item" />
        </div>
      </div>
      <div
        ref="backRef"
        class="hidden flex-y-center justify-center group-hover:flex-y-center nav-btn nav-btn-go left-20"
        @click="() => switchDirection('back')"
        @pointerover="isHover = true"
        @pointerleave="isHover = false"
      >
        <ArrowRight class="text-[22px] text-[var(--x-text-3)]" />
      </div>
      <div
        ref="goRef"
        class="hidden justify-center group-hover:flex-y-center nav-btn right-20"
        @click="() => switchDirection('go')"
        @pointerover="isHover = true"
        @pointerleave="isHover = false"
      >
        <ArrowRight class="text-[22px] text-[var(--x-text-3)]" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRafFn } from '@vueuse/core';
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
import ArticleCard from '../article-card.vue';

const OFFSET = 200;

const props = defineProps<{ data: any }>();
const emits = defineEmits(['click']);
const containerRef = ref();
// const { isTargetVisible } = useTargetVisible(containerRef)
const backRef = ref();
const goRef = ref();
const translateX = ref(0);
const direction = ref<'left' | 'right'>('left');

const [isAnimating, setAnimate] = useToggle(true);
// const isAnimating = ref(true) // 控制动画状态

const list = ref<HTMLDivElement>();
const isHover = ref(false);
const visibility = useElementVisibility(containerRef);
const { width, height } = useElementSize(list);
const pixelsMovedPerFrameOnIdle = 1.0;

useRafFn(() => {
  if (isAnimating.value && visibility.value) {
    const bound = width.value;
    if (bound) {
      const pixelsMovedPerFrame = pixelsMovedPerFrameOnIdle;
      const newTranslateX = translateX.value + pixelsMovedPerFrame;

      if (newTranslateX > bound) {
        translateX.value = 0;
      } else {
        translateX.value = newTranslateX;
      }
    }
  }
});

const style = computed(() => {
  const bound = width.value;
  const newValue = direction.value === 'left' ? -translateX.value : translateX.value - bound;
  return {
    transform: `translateX(${newValue}px)`,
  };
});

const switchDirection = (newDirection: 'go' | 'back') => {
  // 先暂停
  setAnimate(false);

  if (newDirection === 'go') {
    // 当前方向快速滚动一段距离
    const targetX = translateX.value + OFFSET;
    // const bound = list.value?.clientWidth || 1920
    const bound = width.value;
    if (targetX > bound) {
      translateX.value = 0;
    } else {
      translateX.value = targetX;
    }
  } else {
    // back 快速往右滚动一段距离
    const targetX = translateX.value - OFFSET;
    const bound = width.value;
    if (targetX < 0) {
      translateX.value = bound;
    } else {
      translateX.value = targetX;
    }
  }

  // 恢复动画
  // setAnimate(true)
};
const setPreviewItem = (item: any | null) => {
  emits('click', item);
};

watch(isHover, hovered => {
  if (hovered) {
    // 直接暂停
    setAnimate(false);
    return;
  }

  const paused = !isAnimating.value;
  if (paused) {
    setAnimate(true);
  }
});

watch(visibility, visible => setAnimate(visible));
</script>
<style lang="scss" scoped>
.nav-btn {
  // @apply flex-y-center justify-center;
  width: 52px;
  height: 52px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 21;
  border-radius: 50%;
  border: 1px solid var(--x-back-6);
  background: var(--x-back-1);
  box-shadow: 0 2px 20px 0 rgba(18, 25, 38, 0.1);
  transition: all 0.3s;
  &:hover {
    background-color: var(--x-back-5);
    border-color: var(--x-back-3);
  }
}
.nav-btn-go {
  transform: translateY(-50%) scaleX(-1);
}
.marquee-track {
  transition: all linear 0.5s;
}
</style>
